module.exports = __webpack_public_path__ + "img/image8.31343ad0.jpg";